function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100",
      maxWidth: "100%"
    },
    xmlSpace: "preserve",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {},
    fill: "#fff",
    id: titleId
  }, "77 all") : title ? /*#__PURE__*/React.createElement("title", {
    style: {},
    fill: "#fff",
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {},
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 81.3,
    width: 18.9,
    height: 6,
    style: {},
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,38.6V11c0-4.4-3.6-8-8-8h-41c-4.4,0-8,3.6-8,8v27.6L14.1,46l7.4,7.4V89c0,4.4,3.6,8,8,8h40.9c4.4,0,8-3.6,8-8V53.4   l7.5-7.4L78.5,38.6z M27.5,11c0-1.1,0.9-2,2-2h40.9c1.1,0,2,0.9,2,2v4.7H27.5V11z M70.5,91h-41c-1.1,0-2-0.9-2-2V77.6h44.9V89h0.1   C72.5,90.1,71.6,91,70.5,91z M60.8,62.6l4.2,4.2l7.5-7.5v12.3h-45V59.4l7.5,7.5l4.2-4.2L22.6,46l16.6-16.6L35,25.1l-7.5,7.5V21.7   h44.9v10.9L65,25.1l-4.2,4.2L77.4,46L60.8,62.6z",
    style: {},
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvvg3);
export default __webpack_public_path__ + "static/media/svvg3.193ff071c8a138f04943f070b7daa4b7.svg";
export { ForwardRef as ReactComponent };